import React from "react";
import {
    primaryText,
    secondaryText,
    greyTextColor,
    darkGreenTextColor,
    borderPrimary,
    placeholderPrimary,
} from "../../../../../../styling/stylingHelper";
import { eur } from "../../../../../orderhistory/utils";

interface MenuItemsTabProps {
    items: any[];
    selectedItem: any;
    onSelectItem: (item: any) => void;
    quantityInputValue: string;
    onQuantityChange: (value: string, numericValue: number) => void;
    calculateEstimatedPrice: () => number | null;
    searchQuery: string;
}

const MenuItemsTab: React.FC<MenuItemsTabProps> = ({
    items,
    selectedItem,
    onSelectItem,
    quantityInputValue,
    onQuantityChange,
    calculateEstimatedPrice,
    searchQuery,
}) => {
    return (
        <div className="flex flex-1 flex-col min-h-0 gap-3 overflow-y-auto">
            {items.length === 0 ? (
                <div className={`p-4 text-center ${greyTextColor}`}>
                    {searchQuery ? "No menu items match your search" : "No other menu items available"}
                </div>
            ) : (
                items.map((item) => {
                    const isSelected = selectedItem?.id === item.id;

                    return (
                        <button
                            key={item.id}
                            type="button"
                            onClick={() => onSelectItem(item)}
                            className={`w-full text-left rounded-lg border py-[11px] pl-3 pr-4 bg-background dark:bg-background-dark flex flex-col transition-colors ${
                                isSelected
                                    ? "border-darkGreenColor dark:border-darkGreenColor-dark"
                                    : borderPrimary
                            }`}
                        >
                            <div className="mb-3 flex items-center justify-between">
                                <p className={`text-[16px] leading-6 font-semibold tracking-[-0.16px] ${primaryText}`}>
                                    {item.costPriceName}
                                </p>
                                {isSelected && (() => {
                                    const estimatedPrice = calculateEstimatedPrice();
                                    return estimatedPrice !== null ? (
                                        <p className={`text-[16px] leading-6 font-semibold ${darkGreenTextColor}`}>
                                            {eur(estimatedPrice)}
                                        </p>
                                    ) : null;
                                })()}
                            </div>

                            <div className="flex items-center justify-between gap-3">
                                <p className={`${greyTextColor} text-[14px] leading-[21px] font-normal tracking-[-0.14px]`}>
                                    Ingredients
                                </p>
                                <p className={`${secondaryText} text-[14px] leading-5 font-medium`}>
                                    {item.ingredients.length}
                                </p>
                            </div>

                            <div className="flex items-center justify-between gap-3 my-2">
                                <p className={`${greyTextColor} text-[14px] leading-[21px] font-normal tracking-[-0.14px]`}>
                                    Unit Price
                                </p>
                                <p className={`${secondaryText} text-[14px] leading-5 font-medium`}>
                                    {eur(item.totalCost)}/portion
                                </p>
                            </div>

                            {isSelected && (
                                <div className="mt-3">
                                    <p className={`${secondaryText} mb-3 text-[16px] leading-5 font-medium`}>
                                        Quantity
                                    </p>
                                    <div className="flex items-center justify-between gap-2 rounded-lg border border-borderGrey dark:border-borderGrey-dark bg-backgroundSecondary dark:bg-backgroundSecondary-dark px-3 h-11">
                                        <input
                                            type="number"
                                            inputMode="decimal"
                                            min={0}
                                            step="any"
                                            placeholder="0.0 portions"
                                            value={quantityInputValue}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
                                                    onQuantityChange(value, value === '' ? 0 : parseFloat(value) || 0);
                                                }
                                            }}
                                            className={`flex-1 bg-transparent dark:bg-transparent text-[14px] leading-5 font-medium ${secondaryText} ${placeholderPrimary} outline-none appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance]:textfield`}
                                        />
                                        <span className={`text-[14px] leading-5 font-medium ${secondaryText}`}>
                                            portions
                                        </span>
                                    </div>
                                </div>
                            )}
                        </button>
                    );
                })
            )}
        </div>
    );
};

export default MenuItemsTab;

